import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

function useTurnsServiceDegraded(initialState: boolean = false) {
    const [isTurnsServiceDegraded, setIsTurnsServiceDegraded] = useState(initialState);
    return { isTurnsServiceDegraded, setIsTurnsServiceDegraded };
}

export const TurnsServiceDegradedStore = createStore(useTurnsServiceDegraded);
export type TurnsServiceDegradedStore = ReturnType<typeof useTurnsServiceDegraded>;
